/* eslint-disable */
// ============================================================
//  native-update.js — Mise a jour in-app (Google Play In-App Update).
//
//  Quand une nouvelle version de l'app est publiee sur le Play Store,
//  Android peut proposer un encart natif "mise a jour disponible"
//  directement dans l'app (telechargement en fond, sans quitter l'app).
//
//  Ce code s'execute DANS l'app native (Capacitor) et pilote le plugin
//  @capawesome/capacitor-app-update via le pont Capacitor.
//
//  ⚠️ Sur le WEB normal (navigateur) et tant que le plugin n'est pas
//  present dans le build natif -> NO-OP total. Zero impact sur le site.
// ============================================================

let started = false;

function getCap() {
  if (typeof window === "undefined") return null;
  const Cap = window.Capacitor;
  if (!Cap || typeof Cap.isNativePlatform !== "function" || !Cap.isNativePlatform()) return null;
  return Cap;
}

// A appeler au demarrage de l'app (App.jsx). Idempotent.
export async function initAppUpdate() {
  const Cap = getCap();
  if (!Cap) return; // web -> no-op
  // Reserve a Android (l'API In-App Update n'existe pas sur iOS ; sur iOS
  // le plugin ne fait que verifier la version App Store, on s'abstient).
  const platform = (typeof Cap.getPlatform === "function") ? Cap.getPlatform() : "";
  if (platform !== "android") return;
  const AU = Cap.Plugins && Cap.Plugins.AppUpdate;
  if (!AU) return; // plugin absent (ancien build) -> no-op
  if (started) return;
  started = true;

  try {
    const info = await AU.getAppUpdateInfo();
    // updateAvailability: 2 = UPDATE_AVAILABLE (constante Play Core)
    if (!info || Number(info.updateAvailability) !== 2) return;

    if (info.flexibleUpdateAllowed) {
      // Flexible = telechargement en arriere-plan, l'utilisateur continue
      // d'utiliser l'app ; quand c'est pret on installe (redemarrage).
      if (typeof AU.addListener === "function") {
        AU.addListener("onFlexibleUpdateStateChange", (state) => {
          // installStatus: 11 = DOWNLOADED
          if (state && Number(state.installStatus) === 11) {
            try { AU.completeFlexibleUpdate(); } catch (e) {}
          }
        });
      }
      await AU.startFlexibleUpdate();
    } else if (info.immediateUpdateAllowed) {
      // Repli : mise a jour immediate (plein ecran bloquant) si le flexible
      // n'est pas autorise pour cette version.
      await AU.performImmediateUpdate();
    }
  } catch (e) { /* silencieux */ }
}
